import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { canAccess } from '../policy/policies';
import { CTE_POLICY } from '../policy/policy';
import { AuthService } from '../services/auth.service';
import { PolicyService } from '../services/policy.service';

export const PolicyGuardService: CanActivateChildFn = (route, state) => {
  const authService = inject(AuthService);
  const policyService = inject(PolicyService);

  const policy = route.data[CTE_POLICY];
  if (!policy) {
    return of(true);
  }
  return new Observable<boolean>((observer) => {
    authService.loadUser().subscribe((user) => {
      observer.next(canAccess(policy, authService.verificator, policyService.getRolesFromPolicies.bind(policyService)));
      observer.complete();
    });
  });
};
